export default __webpack_public_path__ + "static/media/placeholder_portfolio03-jp-mobile.85094244.png";